export enum CompanyPartner {
  NONE = '',
  B2B2C = 'B2B2C',
  B2B2E = 'B2B2E',
  NISSAN = 'NISSAN',
  GOINGREEN = 'GOINGREEN',
}
